module.exports = __webpack_public_path__ + "static/media/SPADE-11-JACK.8b653aab.svg";